import {createResourcesProxy, waitForCSS} from '@parcel/runtime-rsc/rsc-helpers';
import {preinit} from 'react-dom';
preinit(parcelRequire.resolve("igRYP"), {as: 'style', precedence: 'default'});
let promise = Promise.all([parcelRequire.load("awzdE"), parcelRequire.load("kWrGa"), parcelRequire.load("lWQ0Q"), parcelRequire.load("i12bk"), parcelRequire.load("cpWCV"), parcelRequire.load("68Spg"), parcelRequire.load("blC0m"), parcelRequire.load("7UfgP")]).then(() => {
let originalModule = parcelRequire("7ohac");
let resources = <>
  <link rel="modulepreload" href={parcelRequire.resolve("awzdE")} />
  <link rel="stylesheet" href={parcelRequire.resolve("igRYP")} precedence="default" />
  <link rel="modulepreload" href={parcelRequire.resolve("kWrGa")} />
  <link rel="modulepreload" href={parcelRequire.resolve("lWQ0Q")} />
  <link rel="modulepreload" href={parcelRequire.resolve("i12bk")} />
  <link rel="modulepreload" href={parcelRequire.resolve("cpWCV")} />
  <link rel="modulepreload" href={parcelRequire.resolve("68Spg")} />
  <link rel="modulepreload" href={parcelRequire.resolve("blC0m")} />
  <link rel="modulepreload" href={parcelRequire.resolve("7UfgP")} />
</>;
let res = createResourcesProxy(originalModule, false, resources );
  return res;
});
module.exports = promise;
